module.exports = __webpack_public_path__ + "media/svg-new/back-3130814d.svg";